export default __webpack_public_path__ + "static/media/hydrogen.ed1a9584.svg";